import { t } from "i18next";

import { EInventoryBoxZone, ETransferDirection } from "../constants";
import { BoxMovement, Transfer, TransferActor } from "../transfers.types";

export const formatTransferRef = (id: string): string =>
  `TR-${id.slice(0, 6).toUpperCase()}`;

export const formatBoxMovementRef = (id: string): string =>
  `BBT-${id.slice(0, 6).toUpperCase()}`;

// "Pickup zone" / "Inventory zone" labels shown in the Box movements Type column.
export const getBoxMovementZoneLabel = (zone: EInventoryBoxZone): string =>
  zone === EInventoryBoxZone.Warehouse ? "Inventory zone" : "Pickup zone";

const actorName = (actor?: TransferActor | null): string => {
  if (!actor) {
    return "";
  }

  if (actor.name) {
    return actor.name;
  }

  const first = actor.firstName ?? actor.firstname;
  const last = actor.lastName ?? actor.lastname;
  const joined = [first, last].filter(Boolean).join(" ").trim();

  return joined || actor.email || "";
};

export const getTransferActorName = (transfer: Transfer): string => {
  const name =
    actorName(transfer.createdByAdmin) ||
    actorName(transfer.createdByInventoryManager);

  return name || t("System");
};

export const getBoxMovementActorName = (movement: BoxMovement): string => {
  const name =
    actorName(movement.createdByAdmin) ||
    actorName(movement.createdByInventoryManager);

  return name || t("System");
};

export const getTransferDirectionZones = (
  direction: ETransferDirection,
): { from: EInventoryBoxZone; to: EInventoryBoxZone } =>
  direction === ETransferDirection.PickupToWarehouse
    ? { from: EInventoryBoxZone.Pickup, to: EInventoryBoxZone.Warehouse }
    : { from: EInventoryBoxZone.Warehouse, to: EInventoryBoxZone.Pickup };
